import Type from "@/model/types/Type";

const type = {
    PENDING: 1,/*Warning*/
    IN_PROGRESS: 2,/*Info*/
    LATE: 3,/*Danger*/
    DONE: 4,/*Success*/
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.IN_PROGRESS,
        text: "Andamento",
    },
    {
        value: type.LATE,
        text: "Atrasada",
    },
    {
        value: type.DONE,
        text: "Realizada",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}